import React, { useEffect,useState } from 'react'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import { adminHeaderApi } from '../../../utils/AdminDashApi/HeaderApi'
import { BiBell } from 'react-icons/bi'
import {Row,Col,Modal} from 'react-bootstrap'
import '../../../sassFiles/sassPages/admindashboard/bill/billlallstyle.scss'
import { billCollectionApi, billInfoHistoryApi, prevCollectionhistoryApi, searchtableApi } from '../../../utils/AdminDashApi/Bill/BillApi'
import { optionsPeriod, optionsbilltype, optionsrcvtype, optionsremark, optionssession } from '../../Helper'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import axios from 'axios';
import moment from 'moment'
import { HighlightRowText } from '../../../pages/adminDashboard/Bill/subComponents/HighlightRowText';
const BillinfoComp = () => {

    const [billnumber,setbillnumber] = useState("")
    const [shift,setshift] = useState("")
    const [totalamount,settotalamount] = useState("")
    const [cancelreason,setcancelreason] = useState("")
    const [session,setsession] = useState("")
    const [myclass,setclass] = useState("")
    const [rcvtype,setrcvtype] = useState("")
    const [rcvtypename,setrcvtypename] = useState("")
    const [classname,setclassname] = useState("")
    const [billamount,setbillamount] = useState("")
    const [vat,setvat] = useState("")
    const [maxdiscount,setmaxdiscount] = useState("")
    const [hsession,sethsession] = useState("")
    const [hclass,sethclass] = useState("")
    const [hrcvtype,serhrcvtype] = useState("")

    const [labelsession,setlabelsession] = useState("")
    const [labelclass,setlabelclass] = useState("")
    const [labelrcvtype,setlabelrcvtype] = useState("")
    const [labelrcvtypename,setlabelrcvtypename] = useState("")
    const [labelclassname,setlabelclassname] = useState("")
    const [labelbillamount,setlabelbillamount] = useState("")
    const [labelvat,setlabelvat] = useState("")
    const [labelmaxdiscount,setlabelmaxdiscount] = useState("")
    const [labelhsession,setlabelhsession] = useState("")
    const [labelhclass,setlabelhclass] = useState("")
    const [labelhrcvtype,setlaberhrcvtype] = useState("")


    const [borderbillnumber,setborderbillnumber] = useState("")
    const [borderid,setborderid] = useState("")
    const [borderstuname,setborderstuname] = useState("")
    const [bordersection,setbordersection] = useState("")
    const [bordershift,setbordershift] = useState("")
    const [bordercancelreason,setbordercancelreason] = useState("")
    const [bordersession,setbordersession] = useState("")
    const [borderclass,setborderclass] = useState("")
    const [borderrcvtype,setborderrcvtype] = useState("")
    const [borderrcvtypename,setborderrcvtypename] = useState("")
    const [borderclassname,setborderclassname] = useState("")
    const [borderbillamount,setborderbillamount] = useState("")
    const [bordervat,setbordervat] = useState("")
    const [bordermaxdiscount,setbordermaxdiscount] = useState("")
    const [borderhsession,setborderhsession] = useState("")
    const [borderhclass,setborderhclass] = useState("")
    const [borderhrcvtype,setborderhrcvtype] = useState("")

    const [creationDateMod1,setcreationDateMod1] = useState("")
    const [labelcreationDateMod1,setlabelcreationDateMod1] = useState("")
    const [bordercreationDateMod1,setbordercreationDateMod1] = useState("")
   
    const [lastUpdateDateMod1,setlastUpdateDateMod1] = useState("")
    const [labellastUpdateDateMod1,setlabellastUpdateDateMod1] = useState("")
    const [borderlastUpdateDateMod1,setborderlastUpdateDateMod1] = useState("")
   

    const handlelastUpdateDateMod1=(activefromval)=>{
        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setlastUpdateDateMod1(moment(dtfinalc).format("YYYY-MM-DD"))
        }
    }
    const handlecreationDateMod1=(activefromval)=>{
        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setcreationDateMod1(moment(dtfinalc).format("YYYY-MM-DD"))
        }
    }


    const [searchkey,setsearchkey] = useState("")

    const headers = {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Methods": "*",
    }

    const [classresponse, setclassresponse] = useState([]);
    //classdropdownload
       useEffect(() => {
           const fetchClassDropdown = async () => {
               try {
                   const classresponse = await axios.get(
                       "https://sass.britishstandardschool.com/api/Public/ClassList",
                       {},
                       headers
                   );
                   setclassresponse(classresponse.data);
                   console.log(classresponse);
               } catch (err) {
                   if (err.classresponse) {
                       console.error(err.classresponse.data);
                       console.log(err.classresponse.status);
                       console.log(err.classresponse.header);
                   } else {
                       console.error(`Error: ${err.message}`);
                   }
               }
           };
           fetchClassDropdown();
       }, []);

    const [screenSize, getDimension] = useState({
        dynamicWidth: window.innerWidth,
        dynamicHeight: window.innerHeight
      });
      const setDimension = () => {
        getDimension({
          dynamicWidth: window.innerWidth,
          dynamicHeight: window.innerHeight
        })
      }
      
      useEffect(() => {
        window.addEventListener('resize', setDimension);
        
        return(() => {
            window.removeEventListener('resize', setDimension);
            
        })
      }, [screenSize])

      const [searchpopulatedata,setsearchpopulatedata] = useState({
        headerid:"",
        id:""
    })
    const handleRowClick=(myitem)=>{
        console.log(myitem.headerid)
        setsearchpopulatedata({...searchpopulatedata,["headerid"]:myitem.headerid})
        console.log("ami clicked")
        setsearchkey("")

    }
    const handleInputSearch = (e)=>{
        setsearchkey(e.target.value)

    }
    const handleSearchButton=()=>{

    }
    const notification = {
        notification:true
    }

    

    const drpfuncsession=(myval,myid)=>{
        setsession(myid)
    }
    const drpfuncclass=(myval,myid)=>{
        setclass(myid)
    }
    const drpfuncrcvtype=(myval,myid)=>{
        setrcvtype(myid)
    }
    const drpfunchsession=(myval,myid)=>{
        sethsession(myid)
    }
    const drpfunchclass=(myval,myid)=>{
        sethclass(myid)
    }
    const drpfunchrcvtype=(myval,myid)=>{
        hrcvtype(myid)
    }

    const handlesave=()=>{
        if(!session && session==""){
            setbordersession("err")
            setlabelsession("Session required")
        }
        else{
            setbordersession("")
            setlabelsession("")
        }
        if(!myclass && myclass==""){
            setborderclass("err")
            setlabelclass("Class required")
        }
        else{
            setborderclass("")
            setlabelclass("")
        }
        if(!rcvtype && rcvtype==""){
            setborderrcvtype("err")
            setlabelrcvtype("Class required")
        }
        else{
            setborderrcvtype("")
            setlabelrcvtype("")
        }
        if(!rcvtypename && rcvtypename==""){
            setborderrcvtypename(true)
            setlabelrcvtypename("Class required")
        }
        else{
            setborderrcvtypename(false)
            setlabelrcvtypename("")
        }
        if(!classname && classname==""){
            setborderclassname(true)
            setlabelclassname("Class required")
        }
        else{
            setborderclassname(false)
            setlabelclassname("")
        }
        if(!billamount && billamount==""){
            setborderbillamount(true)
            setlabelbillamount("Class required")
        }
        else{
            setborderbillamount(false)
            setlabelbillamount("")
        }
        if(!vat && vat==""){
            setbordervat(true)
            setlabelvat("Class required")
        }
        else{
            setbordervat(false)
            setlabelvat("")
        }
        if(!maxdiscount && maxdiscount==""){
            setbordermaxdiscount(true)
            setlabelmaxdiscount("Class required")
        }
        else{
            setbordermaxdiscount(false)
            setlabelmaxdiscount("")
        }

        if(session &&
            myclass &&
            rcvtype &&
            rcvtypename &&
            classname &&
            billamount &&
            vat &&
            maxdiscount){
                console.log("DONE")
            }

    }

    const handleEditBillInfo=(e,myitem)=>{

    }
  return (
    <>
         <div className="f-flex flexvaluecomp">
            <SidebarOfAdash/>

            <div className="contentpartwidthwrapper" style={screenSize.dynamicHeight<925 ? {marginBottom:"75px"}:{}}>
                <div className="headerofadash billpart">
                <div className="left">
                    <div className="leftsidesearch">
                        <input type="text" value={searchkey} onChange={handleInputSearch} name="searchword" placeholder='Search Student'/>
                        <span onClick={handleSearchButton}>
                            <img src="./assets/images/dashboards/adminDashboard/bill/searchbutton.png" alt="" />
                        </span>
                    <div className= {searchkey.length>0?"searchtable d-block":"searchtable d-none"}>
                    <div className="wrapper">

                        <div className="billentrytoptable searchtablediv">
                        <table>
                            <thead>
                            <tr>                                
                            {
                                searchtableApi.heading.map((item,key)=>{
                                    return(
                                        <th key={key}>{item.head}</th>
                                    )
                                })
                            }
                        </tr>
                            </thead>
                        <tbody>

                        {
                            searchtableApi.data.map((item,key)=>{
                                if(item.name.toLowerCase().includes(searchkey.toLowerCase())){

                                    return(
                                        <tr style={{cursor:"pointer"}} onClick={()=>handleRowClick(item)}>
                                            <td>{item.headerid}</td>
                                            <td>{item.id}</td>
                                            
                                             <HighlightRowText text={item.name} searchText={searchkey} />
                                            <td>{item.class}</td>
                                            <td>{item.section}</td>
                                            <td>{item.status}</td>
                                           
                                        </tr>
                                    )
                                }
                            })
                        }
                        </tbody>
                        </table>

                        </div>
                        </div>
                    </div>
                    </div>

                </div>
                <div className="right">
                    {
                        notification.notification==true?
                        <div className="belldiv">
                            <BiBell/>
                        </div>
                        :
                        <BiBell/>
                     }
                    <div className="displaypic">
                        <img src="./assets/images/dashboards/adminDashboard/header/DP.png" alt="" />
                    </div>
                    <div className="nameandid">
                        <h5>{adminHeaderApi.name}</h5>
                        <p>ID {adminHeaderApi.id}</p>
                    </div>
                </div>
            </div>

            <div className=" contentflexvalue billcontent billupdate w100">
                <Row>
                    <Col lg={12} className="pd15">  
                        <div className="smallheader d-flex">
                            <h4>Create New Bill Info</h4>
                        </div>
                        <div className="billbox small morph">
            
                        <Row className="w825 m-auto">
                            <Col lg={3} className="pr5">
                            <div className="left w130">
                                    <p>Session</p>
                                </div>
                                <div className="right">
                                <div className="inputgap h35">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={bordersession} func={drpfuncsession} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionssession} />
                                </div>
                                <label>{labelsession}</label>
                                    
                                </div>
                                </div>
                            </Col>
                            <Col lg={3} className="pr5 pl5">
                            <div className="left w130">
                                    <p>Class</p>
                                </div>
                                <div className="right">
                                <div className="inputgap h35">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={borderclass} func={drpfuncclass} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={classresponse} />
                                </div>
                                <label>{labelclass}</label>
                                    
                                </div>
                                </div>
                            </Col>
                            <Col lg={3} className="pr5 pl5">
                            <div className="left w130">
                                    <p>Receive Types</p>
                                </div>
                                <div className="right">
                                <div className="inputgap h35">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={borderrcvtype} func={drpfuncrcvtype} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsrcvtype} />
                                </div>
                                <label>{labelrcvtype}</label>
                                    
                                </div>
                                </div>
                            </Col>
                            <Col lg={3} className="pl5">
                            <div className="left w130">
                                    <p>Receive Type Name</p>
                                </div>
                                <div className="right">
                                <div className="inputgap h35">
                                <input type="text" style={borderrcvtypename ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }}  value={rcvtypename} onChange={(e)=>setrcvtypename(e.target.value) } />
                                <label>{labelrcvtypename}</label>
                                    
                                </div>
                                </div>
                            </Col>
                            <Col lg={3} className="pr5 mt-2">
                            <div className="left w130">
                                    <p>Class Name</p>
                                </div>
                                <div className="right">
                                <div className="inputgap h35">
                                <input type="text" style={borderclassname ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }}  value={classname} onChange={(e)=>setclassname(e.target.value) } />
                                <label>{labelclassname}</label>
                                    
                                </div>
                                </div>
                            </Col>
                            <Col lg={3} className="pr5 pl5 mt-2">
                            <div className="left w130">
                                    <p>Bill Amount</p>
                                </div>
                                <div className="right">
                                <div className="inputgap h35">
                                <input type="text" style={borderbillamount ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }}  value={billamount} onChange={(e)=>setbillamount(e.target.value) } />
                                <label>{labelbillamount}</label>
                                    
                                </div>
                                </div>
                            </Col>
                            <Col lg={3} className="pr5 pl5 mt-2">
                            <div className="left w130">
                                    <p>Vat</p>
                                </div>
                                <div className="right">
                                <div className="inputgap h35">
                                <input type="text" style={bordervat ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }}  value={vat} onChange={(e)=>setvat(e.target.value) } />
                                <label>{labelvat}</label>
                                    
                                </div>
                                </div>
                            </Col>
                            <Col lg={3} className="pr5 pl5 mt-2">
                            <div className="left w130">
                                    <p>Max Discount</p>
                                </div>
                                <div className="right">
                                <div className="inputgap h35">
                                <input type="text" style={bordermaxdiscount ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }}  value={maxdiscount} onChange={(e)=>setmaxdiscount(e.target.value) } />
                                <label>{labelmaxdiscount}</label>
                                    
                                </div>
                                </div>
                            </Col>
                        </Row>

                        <div className="text-center savebutton">
                            <button onClick={handlesave}>Save</button>
                        
                        </div>
                        </div>                                
                    </Col>
                </Row>
                <Row>
                    <Col lg={12} className="pd15">  
                        <div className="smallheader d-flex">
                            <h4>Bill Info History</h4>
                        </div>
                        <div className="billbox small morph">
            
                        <div className="w615 m-auto">
                            <Row>
                                <Col lg={4}>
                                <div className="left w130">
                                    <p>Session</p>
                                </div>
                                <div className="right">
                                <div className="inputgap h35">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={false} func={drpfunchsession} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionssession} />
                                </div>
                                
                                    
                                </div>
                                </div>
                                </Col>
                                <Col lg={4}>
                                <div className="left w130">
                                    <p>Class</p>
                                </div>
                                <div className="right">
                                <div className="inputgap h35">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={false} func={drpfunchclass} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={classresponse} />
                                </div>
                                
                                    
                                </div>
                                </div>
                                </Col>
                                <Col lg={4}>
                                <div className="left w130">
                                    <p>Receive Types</p>
                                </div>
                                <div className="right">
                                <div className="inputgap h35">
                                <div className="dropdownwrapper">
                                <Dropdown2 err={false} func={drpfunchrcvtype} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionsrcvtype} />
                                </div>
                                
                                    
                                </div>
                                </div>
                                </Col>
                            </Row>
                        </div>

                        <div className="billentrytoptable billinfohistorytable mt-4">
                            <table style={{height:"unset"}}>
                                <thead>
                                <tr style={{border:"none"}}>                                
                                {
                                    billInfoHistoryApi.heading.map((item,key)=>{
                                        return(
                                            <th style={{border:"1px dashed rgba(0,0,0,0.2)"}} key={key}>{item.head}</th>
                                        )
                                    })
                                }
                            </tr>
                                </thead>
                            <tbody>
                           
                            {
                                billInfoHistoryApi.data.map((item,key)=>{
                                    return(
                                        <tr style={{border:"none"}}>
                                            <td style={{border:"1px dashed rgba(0,0,0,0.2)",height:"40px"}}></td>
                                            <td style={{border:"1px dashed rgba(0,0,0,0.2)",height:"40px"}}></td>
                                            <td style={{border:"1px dashed rgba(0,0,0,0.2)",height:"40px"}}></td>
                                            <td style={{border:"1px dashed rgba(0,0,0,0.2)",height:"40px"}}></td>
                                            <td style={{border:"1px dashed rgba(0,0,0,0.2)",height:"40px"}}></td>
                                            <td style={{border:"1px dashed rgba(0,0,0,0.2)",height:"40px"}}></td>
                                            <td style={{border:"1px dashed rgba(0,0,0,0.2)",height:"40px"}}></td>
                                            <td style={{border:"1px dashed rgba(0,0,0,0.2)",height:"40px"}}></td>
                                            <td style={{border:"1px dashed rgba(0,0,0,0.2)",height:"40px"}}></td>
                                            <td style={{border:"1px dashed rgba(0,0,0,0.2)",height:"40px"}}></td>
                                            <td style={{border:"1px dashed rgba(0,0,0,0.2)",height:"40px"}}>
                                                <div className="img text-center">
                                                <img onClick={(e)=> handleEditBillInfo(e,item)} src="./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png" alt="" />  
                                                </div>  
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                            
                            </div>
                        </div>                                
                    </Col>
                </Row>

                {/* modal2ori */}
              {/* <Modal dialogClassName="mymodalmenueid" show={show3} onHide={handleClose2} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Session Entry edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={10} className="m-auto">
                      <Row>
                        
                       
                      
                      
                        
                    
                        <Col lg={4} className="pr7">
                  <div className="basicinput modalinputgap">
                    <p>Last Update Date</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div className="inputgap">
                      <DatePicker
                          
                          value={lastUpdateDateMod1}
                          onChange={(newvaldob)=>handlelastUpdateDateMod1(newvaldob)}
                          renderInput={(params) => <TextField {...params}
                          style={borderlastUpdateDateMod1=="err"?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}}  inputProps={{
                              ...params.inputProps,
                              placeholder: "Start Date"
                            }} error={false} />}
                      />
                      <label>{labellastUpdateDateMod1}</label>
                      </div>
                    </LocalizationProvider>
                  </div>
                </Col>
                <Col lg={4} className='pl7 pr7'>
                  <div className="basicinput">
                    <p>Creation Date</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div className="inputgap">
                      <DatePicker
                          
                          value={creationDateMod1}
                          onChange={(newvaldob)=>handlecreationDateMod1(newvaldob)}
                          renderInput={(params) => <TextField {...params}  style={bordercreationDateMod1=="err"?{border:"1px solid #ED1C24",borderRadius:"10px"}:{}}  inputProps={{
                              ...params.inputProps,
                              placeholder: "End Date"
                            }} error={false} />}
                      />
                      <label>{labelcreationDateMod1}</label>
                      </div>
                    </LocalizationProvider>
                  </div>
                </Col>
               

                       
                      </Row>
                   
                    </Col>
                    
                  </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleClose2}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal2}>
                    Save
                  </button>
                </Modal.Footer>
              </Modal> */}
            </div>
            </div>
            </div>
    </>
  )
}

export default BillinfoComp